import React, { useState } from 'react';
import { X, File } from 'lucide-react';
import { useTranslation } from 'react-i18next';


interface ChatConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (needsConfirmation: boolean) => void;
  fileName: string;
  filePreview: string | null;
  fileType: string;
}

const ChatConfirmationModal: React.FC<ChatConfirmationModalProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  fileName, 
  filePreview,
  fileType
}) => {
  const [needsConfirmation, setNeedsConfirmation] = useState(false);
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white p-6 rounded-lg max-w-lg w-full">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">{t("confirm")}</h2>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
          >
            <X size={24} />
          </button>
        </div>
        <div className="mb-4">
          {filePreview ? (
            fileType.startsWith('image/') ? (
              <img src={filePreview || "/placeholder.svg"} alt="File preview" className="max-w-full h-auto max-h-64 object-contain" />
            ) : fileType.startsWith('video/') ? (
              <video src={filePreview} controls className="max-w-full h-auto max-h-64" />
            ) : (
              <div className="flex items-center justify-center bg-gray-100 h-64">
                <File size={48} className="text-gray-400" />
                <span className="ml-2 text-gray-600">{fileName}</span>
              </div>
            )
          ) : (
            <div className="flex items-center justify-center bg-gray-100 h-64">
              <span className="text-gray-600">{t('no_preview')}</span>
            </div>
          )}
        </div>
        <p className="mb-4">{t('sure_send')}</p>
        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={needsConfirmation}
              onChange={(e) => setNeedsConfirmation(e.target.checked)}
              className="form-checkbox h-5 w-5 text-blue-600"
            />
            <span className="ml-2 text-gray-700">{t('message_need_confirm')}</span>
          </label>
        </div>
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(needsConfirmation)}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatConfirmationModal;

